import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Icon from "@/components/common/Icon";
import SEO from "@/components/SEO";
import { PageHero } from "@/components/common/Bits";
import { Reveal } from "@/components/motion/Reveal";
import { SPECIAL_SOLUTIONS } from "@/data/services";

export default function SpecialIndex() {
    return (
        <>
            <SEO
                title="Other Solutions — Spalling Concrete, Mould Treatment & Events"
                path="/special-solutions"
                description="Other property solutions from ProCare.SG: spalling concrete repairs, mould treatment and events set-up in Singapore."
            />
            <PageHero
                label="Other Solutions"
                title="Specialist CARE Beyond Everyday Works"
                subtitle="From spalling concrete and mould to full events set-up — solutions for the jobs that need a specialist team."
                image="/images/spalling.webp"
            />
            <section className="py-24">
                <div className="mx-auto grid max-w-7xl gap-6 px-6 lg:grid-cols-2">
                    {SPECIAL_SOLUTIONS.map((s, i) => (
                        <Reveal key={s.slug} delay={i * 0.1}>
                            <Link
                                to={`/special-solutions/${s.slug}`}
                                data-testid={`special-index-${s.slug}`}
                                className="group flex h-full flex-col overflow-hidden rounded-[28px] bg-white shadow-brand transition-all duration-300 hover:-translate-y-1 hover:shadow-brand-lg"
                            >
                                <div className="relative aspect-[16/9] overflow-hidden">
                                    <img src={s.image} alt={s.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                                    <div className="absolute inset-0 bg-brand-blue/40" />
                                    <div className="absolute bottom-5 left-5 flex items-center gap-3 text-white">
                                        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-red">
                                            <Icon name={s.icon} className="h-6 w-6" />
                                        </div>
                                        <h2 className="font-display text-2xl font-semibold">{s.name}</h2>
                                    </div>
                                </div>
                                <div className="flex flex-1 flex-col p-7">
                                    <p className="flex-1 text-sm leading-relaxed text-brand-ink/60">{s.intro}</p>
                                    <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-brand-red">
                                        {s.cta} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                                    </span>
                                </div>
                            </Link>
                        </Reveal>
                    ))}
                </div>
            </section>
        </>
    );
}
